<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M14.52 18.23l3.84-2.22-3.84-2.22v4.44z"/><path d="M25 5H7a2 2 0 00-2 2v18a2 2 0 002 2h18a2 2 0 002-2V7a2 2 0 00-2-2zm-1.91 14.57a1.85 1.85 0 01-1.31 1.3 44.06 44.06 0 01-5.78.31 44.14 44.14 0 01-5.78-.31 1.89 1.89 0 01-1.31-1.3 19.86 19.86 0 01-.3-3.57 19.8 19.8 0 01.3-3.56 1.88 1.88 0 011.31-1.31 44.14 44.14 0 015.78-.3 44.06 44.06 0 015.78.31 1.85 1.85 0 011.31 1.31A19.17 19.17 0 0123.4 16a19.23 19.23 0 01-.31 3.57z"/></svg>